import { cx } from './cx.ts'

/**
 * The Robotensor mark: nine triangular shards swept around an empty centre, in a 100 × 100 box.
 * Geometry traced from the company identity (logo-shards.json). Every shard is solid currentColor (ink: black in
 * the light theme, near-white in the dark one), never shaded: the brand uses the flat mark on every site.
 */
const SHARDS: readonly { points: readonly (readonly [number, number])[]; angle: number }[] = [
  { points: [[23.54, 58.88], [36.83, 93.64], [20.74, 89.91]], angle: -143.3 },
  { points: [[5.38, 65.8], [24.27, 45.51], [14.71, 76.76]], angle: -109.82 },
  { points: [[9.49, 38.6], [30.02, 36.97], [9.03, 49.56]], angle: -76.23 },
  { points: [[26.53, 23.01], [37.73, 37.47], [18.6, 27.9]], angle: -47.45 },
  { points: [[39.4, 24.95], [46.63, 28.22], [41.73, 42.91]], angle: -22.41 },
  { points: [[47.43, 0], [73.33, 10.26], [60.26, 62.05]], angle: 21.77 },
  { points: [[81.79, 20.73], [94.62, 41.03], [59.4, 70.42]], angle: 78.27 },
  { points: [[47.22, 77.52], [92.24, 61.19], [87.11, 81.72]], angle: 132.61 },
  { points: [[32.07, 72.24], [69.86, 90.44], [54.23, 100]], angle: 176.87 },
]

export function ShardMark({ size, className, title }: { size?: number; className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={cx('rt-mark', className)}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      {SHARDS.map((s, i) => (
        <polygon key={i} points={s.points.map(([x, y]) => `${x},${y}`).join(' ')} fill="currentColor" />
      ))}
    </svg>
  )
}
